export default {
  REQUIRED: "Поле обов'язкове",
  ONLY_POSITIVE: "Поле має містити позитивне значення",
  AMOUNT_AND_BALANCE_CORRECTION: "Сума не може бути від'ємною без введення залишків",
  COMMENTS: "Необхідно обов'язково вказати обгрунтування нарахування Бонусних годин (у полі Примітки)",
  PASSWORD: "Щонайменше 8 символів",
  EMAIL: "Не коректниій Email",
  LOG_TIME: "Не коректниій час",
};